import { Component, OnInit, Input, EventEmitter, AfterViewInit, Output, ElementRef, Optional, Renderer2 } from '@angular/core';
import { DataTableColumn, deepCopy, convertColumns } from '../datatable-column';
import { DataTableComponent } from '../datatable.component';
@Component({
    selector: 'datatable-header',
    template: `
    <table class="table"
    [class.table-sm]="size==='small'"
    [class.table-striped]="striped"
    [class.table-bordered]="bordered" style="margin:0">
        <thead class="thead-light">
            <tr>
                <th class="dt-checkbox-cell" *ngIf="!dt.singleSelect" style="width:50px">
                    <dt-checkbox [checked]="isCheckAll" (checkedChange)="onCheckedChange($event)"></dt-checkbox>
                    <span class="column-resize-handler" resize></span>
                </th>
                <th style="width:50px" *ngIf="dt.showLineNumber">
                   #
                   <span class="column-resize-handler" resize></span>
                </th>
                <ng-container *ngFor="let col of columns;let i=index">
                    <th [style.textAlign]="col.align||'left'" [style.width]="col.width+'px'"
                    (click)="sort($event,col)" *ngIf="!col.hidden">
                        {{ col.title }}
                        <i class="iconfont icon-tubiao_jiyao-xiangshang" *ngIf="col.direction==='asc'"></i>
                        <i class="iconfont icon-tubiao_jiyao-xiangxia" *ngIf="col.direction==='desc'"></i>
                        <span class="column-resize-handler" resize></span>
                    </th>
                </ng-container>
            </tr>
        </thead>
    </table>
    `
})
export class DataTableHeaderComponent implements OnInit, AfterViewInit {
    // æ¯å¦å¨é
    isCheckAll = false;
    /* è¡¨æ ¼å°ºå¯¸ */
    get size(): string {
        return this.dt.size;
    }
    /* è¡¨æ ¼åæ°æ® */
    get columns(): DataTableColumn[] {
        return this.dt.columns;
    }
    /* æé©¬æ ·å¼ */
    get striped(): boolean {
        return this.dt.striped;
    }
    /* è¾¹æ¡ */
    get bordered(): boolean {
        return this.dt.bordered;
    }
    /* æ¯å¦åé */
    get isSingle(): boolean {
        return this.dt.singleSelect;
    }
    /* checkbox éä¸­äºä»¶ä¼ æ­ */
    @Output() checkedAll = new EventEmitter();
    /* æåº äºä»¶ä¼ æ­ */
    @Output() sortChange = new EventEmitter();

    constructor(public dt: DataTableComponent) {
    }

    ngOnInit() {

    }

    ngAfterViewInit() {

    }

    /* checkbox äºä»¶ */
    onCheckedChange($event: any) {
        this.isCheckAll = $event.checked;
        this.checkedAll.emit($event.checked);
    }
    /* æåº */
    sort(event: MouseEvent, col: DataTableColumn) {
        this.dt.sortData(event, col);
    }

}
